module.exports = __webpack_public_path__ + "img/core42.d82f67ee.png";